import { get, post } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';
import { loadPaymentSubProviders, setDeliveryMethods } from './Checkout.action';

export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_HIDE = 'CART_HIDE';

export const load = () => (dispatch, getState) => {
    return get('/api/cart')
        .then(response => response.json())
        .then(cart => {
            let dataToUse = 'data' in cart ? cart.data : cart;
            dispatch(receive(dataToUse));
            dispatch(loadPaymentSubProviders());
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const loadError = error => ({
    type: CART_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = cart => ({
    type: CART_RECEIVE,
    payload: cart,
})

export const toggle = () => (dispatch, getState) => {
    dispatch(show(!getState().cart.showInfo));
}

export const show = visible => ({
    type: CART_SHOW_INFO,
    payload: {
        showInfo: visible,
    }
})

/**
 * @param {string} articleNumber
 * @param {number} quantity
 * @param {string|null} nodeIdToShowNotification
 * @param {string|null} notificationMessage
 * @param {string} hash
 * @param {boolean} openMiniCartAtCheckout
 * @returns {function(*): *}
 */
export const add = ({
    articleNumber,
    quantity = 1,
    nodeIdToShowNotification = null,
    notificationMessage = null,
    hash = '',
    openMiniCartAtCheckout = true
}) => {
    return (dispatch, getState) => {
        if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
            return;
        }

        const { cart } = getState();

        return post('/api/cart/add', { articleNumber, quantity: parseInt(quantity) })
            .then(response => response.json())
            .then(result => {
                dispatch(receive(result.data));
                dispatch(loadPaymentSubProviders());
                document.getElementById('hdncartQty').value = new Number(result.quantity)

                switch (result.result) {
                    case -1:
                        dispatch(showNotification(nodeIdToShowNotification, "Stock Exceeded!", hash));
                        break;
                    case 0:
                        openMiniCartAtCheckout && dispatch(toggleminicart())
                        dispatch(showNotification(nodeIdToShowNotification, "Stock Exceeded!", hash));
                        break;
                    case 1:
                        openMiniCartAtCheckout && dispatch(toggleminicart())
                        break;
                }

                if (cart.checkoutUrl === location.pathname) {
                    document.dispatchEvent(new CustomEvent('checkoutAddToCart'));
                }
            })
            .catch(ex => dispatch(catchError(ex, error => loadError(error))));
    }
}
export const toggleminicart = () => (dispatch, getState) => {
    dispatch(show(true));
}

export const reorder = ({ orderId, nodeIdToShowNotification = null, notificationMessage = null, hash = '' }) => {
    if (orderId) {
        return (dispatch) => {
            return post('/api/cart/reorder', { orderId })
                .then(response => response.json())
                .then(result => {
                    dispatch(receive(result.data));
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash));
                })
                .catch(ex => dispatch(catchError(ex, error => loadError(error))));
        }
    }
}

export const update = (rowSystemId, quantity) => (dispatch) => {
    if (isNaN(quantity) || parseInt(quantity) < 0) {
        return;
    }

    return post('/api/cart/update', { rowSystemId, quantity })
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result.data));
            dispatch(updateDeliveryMethods());

            switch (result.result) {
                case -1:
                    dispatch(showNotification(nodeIdToShowNotification, "Stock Exceeded!", hash));
                    break;
                case 0:
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash))
                    break;
                case 1:
                    nodeIdToShowNotification && dispatch(showNotification(nodeIdToShowNotification, notificationMessage, hash))
                    break;
            }
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}

export const updateDeliveryMethods = () => (dispatch) => {
    return get('/api/checkout/updateDeliveryMethods')
        .then(response => response.json())
        .then(result => {
            dispatch(setDeliveryMethods(result.deliveryMethods));
        })
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
};
